import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import Chip from "@mui/material/Chip";
import { Box } from "../Box/index.js";
import { Counter } from "../Counter/index.js";
import { Typography } from "../Typography/index.js";
import { EllipsisText } from "../EllipsisText/index.js";
import { ChipColor, ChipSize } from "./ColoredChip.types.js";
import { colorScheme, useStyles } from "./ColoredChip.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ColoredChip_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ColoredChip_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const isChipColor = (str)=>'string' == typeof str && Object.values(ChipColor).includes(str);
const ColoredChip = (t0)=>{
    const $ = c(73);
    let borderColor;
    let counter;
    let endIcon;
    let onClick;
    let rest;
    let startIcon;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let width;
    if ($[0] !== t0) {
        ({ label: t1, fullWidth: t2, width, startIcon, endIcon, counter, size: t3, color: t4, borderColor, disabled: t5, counterSticked: t6, signed: t7, onClick, isBgWhite: t8 } = t0), rest = _object_without_properties(t0, [
            "label",
            "fullWidth",
            "width",
            "startIcon",
            "endIcon",
            "counter",
            "size",
            "color",
            "borderColor",
            "disabled",
            "counterSticked",
            "signed",
            "onClick",
            "isBgWhite"
        ]);
        $[0] = t0;
        $[1] = borderColor;
        $[2] = counter;
        $[3] = endIcon;
        $[4] = onClick;
        $[5] = rest;
        $[6] = startIcon;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = width;
    } else {
        borderColor = $[1];
        counter = $[2];
        endIcon = $[3];
        onClick = $[4];
        rest = $[5];
        startIcon = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        width = $[15];
    }
    const label = void 0 === t1 ? "" : t1;
    const fullWidth = void 0 === t2 ? false : t2;
    const size = void 0 === t3 ? "small" : t3;
    const color = void 0 === t4 ? ChipColor.gray : t4;
    const disabled = void 0 === t5 ? false : t5;
    const counterSticked = void 0 === t6 ? false : t6;
    const signed = void 0 === t7 ? false : t7;
    const isBgWhite = void 0 === t8 ? false : t8;
    const t9 = ChipSize[size];
    const t10 = isChipColor(color) ? ChipColor[color] : ChipColor.gray;
    let t11;
    if ($[16] !== borderColor || $[17] !== disabled || $[18] !== fullWidth || $[19] !== isBgWhite || $[20] !== t10 || $[21] !== t9 || $[22] !== width) {
        t11 = {
            size: t9,
            fullWidth,
            color: t10,
            borderColor,
            disabled,
            width,
            isBgWhite
        };
        $[16] = borderColor;
        $[17] = disabled;
        $[18] = fullWidth;
        $[19] = isBgWhite;
        $[20] = t10;
        $[21] = t9;
        $[22] = width;
        $[23] = t11;
    } else t11 = $[23];
    const { classes } = useStyles(t11);
    const disabledCounterBgColor = disabled ? "gray" : void 0;
    const counterBgColor = isBgWhite ? null != disabledCounterBgColor ? disabledCounterBgColor : colorScheme[color].counterBgColor : void 0;
    let t12;
    if ($[24] !== classes.chipLabel) {
        t12 = classnames(classes.chipLabel, "aqa_chip_label");
        $[24] = classes.chipLabel;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== classes.icon || $[27] !== classes.startIcon || $[28] !== label || $[29] !== startIcon) {
        t13 = startIcon && /*#__PURE__*/ jsx(Box, {
            className: classnames(classes.icon, !!label && classes.startIcon, "aqa_chip_start_icon"),
            children: startIcon
        });
        $[26] = classes.icon;
        $[27] = classes.startIcon;
        $[28] = label;
        $[29] = startIcon;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== classes.chipLabelTypography || $[32] !== label || $[33] !== size) {
        t14 = label && /*#__PURE__*/ jsx(Typography, {
            className: classes.chipLabelTypography,
            variant: "extraSmall" === size ? "caption" : "body3",
            children: /*#__PURE__*/ jsx(EllipsisText, {
                rows: 1,
                wordBreak: "break-all",
                children: label
            })
        });
        $[31] = classes.chipLabelTypography;
        $[32] = label;
        $[33] = size;
        $[34] = t14;
    } else t14 = $[34];
    let t15;
    if ($[35] !== classes.endIcon || $[36] !== classes.icon || $[37] !== endIcon || $[38] !== label) {
        t15 = endIcon && /*#__PURE__*/ jsx(Box, {
            className: classnames(classes.icon, !!label && classes.endIcon, "aqa_chip_end_icon"),
            children: endIcon
        });
        $[35] = classes.endIcon;
        $[36] = classes.icon;
        $[37] = endIcon;
        $[38] = label;
        $[39] = t15;
    } else t15 = $[39];
    let t16;
    if ($[40] !== classes.counter || $[41] !== counter || $[42] !== counterBgColor || $[43] !== counterSticked || $[44] !== signed || $[45] !== size) {
        t16 = void 0 !== counter && !counterSticked && /*#__PURE__*/ jsx(Counter, {
            className: classnames("aqa_chip_counter", classes.counter),
            counter: counter,
            size: size,
            signed: signed,
            backgroundColor: counterBgColor
        });
        $[40] = classes.counter;
        $[41] = counter;
        $[42] = counterBgColor;
        $[43] = counterSticked;
        $[44] = signed;
        $[45] = size;
        $[46] = t16;
    } else t16 = $[46];
    let t17;
    if ($[47] !== t12 || $[48] !== t13 || $[49] !== t14 || $[50] !== t15 || $[51] !== t16) {
        t17 = /*#__PURE__*/ jsxs("div", {
            className: t12,
            children: [
                t13,
                t14,
                t15,
                t16
            ]
        });
        $[47] = t12;
        $[48] = t13;
        $[49] = t14;
        $[50] = t15;
        $[51] = t16;
        $[52] = t17;
    } else t17 = $[52];
    const resultLabel = t17;
    const t18 = classes.container;
    let t19;
    if ($[53] !== classes.chip || $[54] !== classes.linkChip || $[55] !== onClick) {
        t19 = classnames(classes.chip, "aqa_chip", ...onClick ? [
            classes.linkChip
        ] : []);
        $[53] = classes.chip;
        $[54] = classes.linkChip;
        $[55] = onClick;
        $[56] = t19;
    } else t19 = $[56];
    let t20;
    if ($[57] !== onClick || $[58] !== rest || $[59] !== resultLabel || $[60] !== t19) {
        t20 = /*#__PURE__*/ jsx(Chip, _object_spread_props(_object_spread({}, rest), {
            className: t19,
            label: resultLabel,
            onClick: onClick
        }));
        $[57] = onClick;
        $[58] = rest;
        $[59] = resultLabel;
        $[60] = t19;
        $[61] = t20;
    } else t20 = $[61];
    let t21;
    if ($[62] !== classes.counterSticked || $[63] !== counter || $[64] !== counterBgColor || $[65] !== counterSticked || $[66] !== signed || $[67] !== size) {
        t21 = void 0 != counter && counterSticked && /*#__PURE__*/ jsx(Counter, {
            className: classnames("aqa_chip_counter", classes.counterSticked),
            counter: counter,
            size: size,
            signed: signed,
            backgroundColor: counterBgColor
        });
        $[62] = classes.counterSticked;
        $[63] = counter;
        $[64] = counterBgColor;
        $[65] = counterSticked;
        $[66] = signed;
        $[67] = size;
        $[68] = t21;
    } else t21 = $[68];
    let t22;
    if ($[69] !== classes.container || $[70] !== t20 || $[71] !== t21) {
        t22 = /*#__PURE__*/ jsxs("div", {
            className: t18,
            "data-testid": "aqa_chip",
            children: [
                t20,
                t21
            ]
        });
        $[69] = classes.container;
        $[70] = t20;
        $[71] = t21;
        $[72] = t22;
    } else t22 = $[72];
    return t22;
};
export { ColoredChip, isChipColor };
